"use strict";
/* eslint-disable max-len */
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeAllPlugins = exports.pluginHost = void 0;
const getResetHost = () => ({
    dataProxy: {},
});
exports.pluginHost = getResetHost();
const removeAllPlugins = () => {
    Object.assign(exports.pluginHost, getResetHost());
};
exports.removeAllPlugins = removeAllPlugins;
